// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { useEffect } from "react";
import { ILabel, ITag } from "../../model/applicationState";
import { FontIcon } from "@fluentui/react";
import TextareaAutosize from 'react-textarea-autosize';

export interface ITagInputItemLabelProps {
    label: ILabel;
    tag?: ITag;
    isOrigin: boolean;
    onLabelEnter?: (label: ILabel) => void;
    onLabelLeave?: (label: ILabel) => void;
    prefixText?: string
    changed?: boolean
    onTagLabelEdit: (tagName: string, text: string) => void;
    predictionResult: any;
}

export interface IFieldItemLabelState {
    inEditMode: boolean,
    fieldValue: string,
    initialValue: string,
    valueChanged: boolean,
}

export interface ITagInputItemLabelState { }

export default function TagInputItemLabel(props: ITagInputItemLabelProps, state: IFieldItemLabelState) {
    const [fieldValue, setFieldValue] = React.useState(null)
    const { label, onLabelEnter, onLabelLeave } = props

    const hasEmptyTextValue = !label.value || label.value.some(value => value.text === '')

    useEffect(() => {
        const labelContent = props.predictionResult.analyzeResult.documentResults[0].fields[label.label];
        const predictionText = (labelContent && labelContent.text) || '';
        setFieldValue(predictionText)
    }, [props.predictionResult, label]);

    const setValue = (value) => {
        setFieldValue(value)
    }

    const handleMouseEnter = () => {
        if (props.onLabelEnter) {
            onLabelEnter(label);
        }
    };

    const handleMouseLeave = () => {
        if (props.onLabelLeave) {
            onLabelLeave(label);
        }
    };


    const onClickOutside = () => {
        props.onTagLabelEdit(props.label.label, fieldValue)
    }

    const textPrefix = props.prefixText ? `${props.prefixText} ` : "";
    const inputValue = `${textPrefix}${fieldValue}`;
    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={"tag-item-label flex-center align-items-center d-flex flex-row"}
        >
            {hasEmptyTextValue &&
                <FontIcon className="draw-region-icon" iconName="FieldNotChanged" />
            }
            <TextareaAutosize
                maxRows={7}
                value={inputValue}
                className="tag-item-label-editable"
                onChange={ev => setValue(ev.target.value)}
                onBlur={onClickOutside}
            />
        </div>
    );
}
